import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-unsuccessful-change-review';

const validator = () => null;

const vFParams = {
  paragraph: 'Please enter additional information about the reasons for the change being unsuccessful and the impact on customer and services.',
};

const paragraphUnsuccessful = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphUnsuccessful };
